// extracted by mini-css-extract-plugin
export var blue = "_2v-f";
export var brand = "_2v-b";
export var darkGrey = "_2v-e";
export var disabled = "_2v-4";
export var disabledSubtle = "_2v-5";
export var error = "_2v-6";
export var green = "_2v-g";
export var grey = "_2v-d";
export var icon = "_2v-0";
export var inherit = "_2v-a";
export var lightGrey = "_2v-c";
export var orange = "_2v-i";
export var pink = "_2v-k";
export var primary = "_2v-1";
export var purple = "_2v-l";
export var red = "_2v-j";
export var secondary = "_2v-2";
export var success = "_2v-9";
export var tertiary = "_2v-3";
export var warning = "_2v-7";
export var warningSecondary = "_2v-8";
export var white = "_2v-m";
export var yellow = "_2v-h";